import React, {Component} from 'react';
import {Dialog, FancyButton} from '../widgets/';
import './WelcomeDialog.css';
import UserType from './UserType';
import sesionActions from './session.actions';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';

export class WelcomeDialog extends Component {
	constructor() {
		super();

		this.state = {
			subscriptionLevel: 'free'
		};

		this.setUserType = userType =>
			this.setState({subscriptionLevel: userType === 'user' ? 'none' : 'free'});
		this.setSubscriptionLevel = subscriptionLevel => this.setState({subscriptionLevel});
		this.onGetstarted = () => {
			this.props.onGetstarted(this.state.subscriptionLevel);
		};
	}

	render() {
		return (
			<Dialog
				buttons={[]}
				onCancel={this.onGetstarted}
				emphasis="Get started"
				title="Welcome to B2Me!">
				<div className="WelcomeDialog">
					<h1>Welcome!</h1>
					<p>
						It's great to have you on board. To get started, we need to know how you're going to use
						B2Me:
					</p>
					<UserType
						checked={this.state.subscriptionLevel === 'none' ? 'user' : 'provider'}
						onChange={this.setUserType}
					/>
					<div className="WelcomeDialog-actions">
						<FancyButton onClick={this.onGetstarted}>Get started!</FancyButton>
					</div>
				</div>
			</Dialog>
		);
	}
}

const ConnectedWelcomeDialog = connect(
	() => ({}),
	dispatch => ({
		onGetstarted: subscriptionLevel => {
			dispatch(sesionActions.acceptWelcome(subscriptionLevel));
			dispatch(uiActions.uiModal(null));
		}
	})
)(WelcomeDialog);

export default ConnectedWelcomeDialog;



// WEBPACK FOOTER //
// ./src/user/WelcomeDialog.js